import React from 'react';
import { Box } from '@mui/material';
import { OrientationRadioGroup } from '../../ChartOptions/Legend/LegendComponents/OrientationRadioGroup';
import { STATE_OPTIONS } from './ButtonContent.constants';

interface StateSelectorProps {
  activeState: 'default' | 'hover';
  setActiveState: (state: 'default' | 'hover') => void;
  iconColor?: string;
  backgroundColor?: string;
}

//state selected like default or hover in which you can change propeties
const StateSelector: React.FC<StateSelectorProps> = ({
  activeState,
  setActiveState,
  iconColor,
  backgroundColor,
}) => {
  return (
    <Box
      sx={{
        borderTop: '1px solid lightgray',
        backgroundColor: backgroundColor,
        marginBottom: '15px',
      }}
    >
      <div className="optionDescription" style={{ marginBottom: '8px', color: iconColor }}>
        Button State
      </div>
      <OrientationRadioGroup
        orientation={activeState}
        options={STATE_OPTIONS}
        onChange={(key) => setActiveState(key as 'default' | 'hover')}
      />
    </Box>
  );
};

export default StateSelector;
